import { Navigate, Outlet } from "react-router-dom";
import { useEffect, useState } from "react";
import { useAuth } from "./useAuth.js";

const ProtectedRoute = ({ redirectTo = "/login" }) => {
  const { isAuthenticated, token } = useAuth();
  const email = '';
  //const [error, setError] = useState("");
  const [isValid, setValid] = useState(null);
  console.log(token);
  useEffect(() => {
    const validateTokenWithServer = async () => {
      //const token = localStorage.getItem("token");
      //isValidToken = false;
console.log(token);
      try {
        const auth_url = "https://api.ope-note.jp/admin/auth.php";
        const response = await fetch(auth_url, {
          method: "POST",
          mode: "cors",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email: email, token: token, mode: "check" }),
        });

        const data = await response.json();
        if (response.ok && data.result) {
          setValid(true);
          // ok
        } else {
          setValid(false);
        }
      } catch (err) {
        //console.log(err);
        setValid(false);
      }

    };
    validateTokenWithServer();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if(isValid == null) {
    return '<div>checking auth...</div>';
  }
//console.log(isAuthenticated);
//console.log(isValid);
  if (isAuthenticated && isValid) {
    return <Outlet />;
  }

//return '<div></div>';
  return <Navigate to={redirectTo} replace />;
};

export default ProtectedRoute;
